import React, { useState } from "react";
import classes from "./APIPlaygroundComponents.module.scss";
import Button from "../UI/Button";
import { Modal } from "react-bootstrap";
import LoadingDots from "../UI/LoadingDots";

const JsonObject = ({ response, isLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isResCopied, setIsResCopied] = useState(false);

  const onOpenModalHandler = () => setIsModalOpen(true);

  const onCloseModalHandler = () => setIsModalOpen(false);

  const onCopyHandler = () => {
    const textToCopy = JSON.stringify(response);
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsResCopied(true);
        setTimeout(() => {
          setIsResCopied(false);
        }, 1500);
      })
      .catch((error) => {
        console.error("Error copying text to clipboard:", error);
      });
  };

  return (
    <div className={`${classes["json-container"]} p-3`}>
      <div className={classes["json-content"]}>
        <div className="d-flex justify-content-between">
          <span className={classes.subtitle}>Response</span>
          <div className="d-flex gap-2">
            <Button onClick={onOpenModalHandler}>Open</Button>
            <Button onClick={onCopyHandler}>Copy</Button>
          </div>
        </div>
        <hr />
        {!isLoading && <pre>{JSON.stringify(response, null, 2)}</pre>}
        {isLoading && (
          <LoadingDots />
        )}
        {isResCopied && (
          <span className={classes["response-copied"]}>Copied!</span>
        )}
      </div>
      <Modal
        show={isModalOpen}
        onHide={onCloseModalHandler}
        dialogClassName={classes["response-modal"]}
      >
        <h4>Response</h4>
        <pre className={classes["pre-response"]}>
          {JSON.stringify(response, null, 2)}
        </pre>
      </Modal>
    </div>
  );
};

export default JsonObject;
